import { eventAjaxDisplayCmsModal } from '../common.js';

$(document).ready(function() {
    hideColorsOutOfStock();
    handleOutOfStockOptions();
    
    prestashop.on('updatedProduct', function(event) {
        hideColorsOutOfStock();
        handleOutOfStockOptions();
    });

    /**
     * #9693 Affichage du mini panier au lieu de la popup
     */
    prestashop.on('updatedBlockCartAfter', function(event) {
        if(!$('body').hasClass('block-cart-open') && $('body#product').length > 0) {
            $('.blockcart.dropdown').find('[data-toggle="dropdown"]').trigger('click');

            // Scroll à la fin du mini panier
            setTimeout(function() {
                if ($(".blockcart__dropdown.show .cart-dropdown__content").length > 0) {
                    $(".blockcart__dropdown.show .cart-dropdown__content").animate({
                        scrollTop: $('.blockcart__dropdown.show .cart-dropdown__content')[0].scrollHeight - $('.blockcart__dropdown.show .cart-dropdown__content')[0].clientHeight
                    }, 500);
                }
            }, 300);
        }
    });

    eventAjaxDisplayCmsModal('.js-product-variants .link-guide-tailles');

});

/**
 * Barre les options qui sont hors stock
 */
function handleOutOfStockOptions() {

    if (typeof combinations === 'undefined') {
        return;
    }
 
    let bigArrayCombinations = []; // Array contenant toutes les combinaisons
    let quantities = []; // Array contenant toutes les quantités (dans le même ordre que les combinaisons)
    for (var key in combinations){
        var combinationValue = combinations[key];
        
        // Pourquoi on le prends de la "list" et pas directement de "attributes"? Parce que la "list" est dans l'ordre
        var attributeValuesArray = convertStringListToArray(combinationValue.list);

        bigArrayCombinations.push(attributeValuesArray);
        quantities.push(combinationValue.quantity);
        
    }

    // Converti toutes les combinaisons dans un arbre
    let tree = convertArraysToJsonTree(bigArrayCombinations, quantities);

    let attributeValuesString = '';

    // On récupère toutes les valeurs des attributs sélectionnés
    $('.js-product-variants input[type="radio"]:checked').each(function() {
        var attributeId = $(this).data('product-attribute');

        if (attributeId) {
            attributeValuesString += $(this).val() + ',';
        }
    });

    // On enlève la dernière virgule et on en fait un tableau
    attributeValuesString = attributeValuesString.slice(0, -1);
    let arraySelected = convertStringListToArray(attributeValuesString);

    let currentElement = [];
    
    //Enfin on parcours l'arbre et on désactive les options qui sont hors stock (hormis pour la 1er option)
    arraySelected.forEach(function(element) {

        if (currentElement.length == 0) {
            currentElement = tree[element];
        } else if (currentElement.sons[element]) {
            currentElement = currentElement.sons[element];
        }

        for (var key in currentElement.sons){
            var treeLeaf = currentElement.sons[key];
            
            if (treeLeaf.quantity == 0) {
                $('.js-product-variants input[type="radio"][value="'+treeLeaf.id+'"]').closest('.custom-control').addClass('option-out-of-stock');
            }   
        }
    });
    
}

/**
 * Converti un array de ce format : [[1,2,3], [1,2,4], [1,2,5]]
 * en un json de ce format : 
 * {
 *  1: {
 *    id: 1,
 *    quantity: X,
 *    sons: {
 *     2: {
 *      id: 2,
 *      quantity: X,
 *      sons: {
 *        3: {
 *          id: 3,
 *          sons: {},
 *          quantity: X
 *        },
 *        4: {
 *          id: 4,
 *          sons: {},
 *          quantity: X
 *       },
 *      5: {
 *          id: 5,
 *          sons: {},
 *          quantity: X
 *      }
 *   }
 * }
 */
function convertArraysToJsonTree(arrays, quantities) {
    var json = {};
  
    for (var i = 0; i < arrays.length; i++) {
      var currentArray = arrays[i];
      var currentObject = json;
      var quantity_nb = quantities[i];
  
      for (var j = 0; j < currentArray.length; j++) {
        var id = currentArray[j];
        var sons = {};
  
        if (!currentObject[id]) {
          currentObject[id] = { id: id, sons: sons, quantity: Math.max(quantity_nb, 0) };
        } else {
          currentObject[id].quantity = Math.max(0, currentObject[id].quantity, quantity_nb);
        }
  
        currentObject = currentObject[id].sons;
      }
    }
  
    return json;
}

/**
 * Permet de cacher les couleurs qui sont hors stock (la 1er option normalement)
 */
function hideColorsOutOfStock() {

    if (typeof combinations === 'undefined') {
        return;
    }

    const isZeroOrBelow = (currentValue) => currentValue <= 0;

    $('.js-product-variants input[type="radio"].input-color:not(:checked)').each(function() {
        let value = parseInt($(this).val(),10);
        let quantitiesOfColors = [];

        for (var key in combinations){
            var combinationValue = combinations[key];
            
            if (combinationValue.attributes.indexOf(value) !== -1) {
                quantitiesOfColors.push(combinationValue.quantity);
            }
        }

        if (quantitiesOfColors.every(isZeroOrBelow)) {
            console.log('out of stock');
            if ($(this).closest('.li-option-container').find('.img-out-of-stock').length == 0) {
                $(this).closest('.li-option-container').find('.custom-control-input-color').after('<img src="/img/cms/utils/img-color-out-of-stock.png" class="img-color-out-of-stock">');
                $(this).closest('.li-option-container').addClass('color-out-of-stock');
            }
        }
    });
}

/**
 * Convert une string du format "'1','2','3'" en un array de ce format : [1,2,3]
 */
function convertStringListToArray(string) {
    // Remplace les simples quotes par rien
    string = string.replace(/'/g, '');
  
    var stringArray = string.split(',');
  
    // Converti les strings en int
    var numberArray = stringArray.map(function(element) {
      return parseInt(element, 10);
    });
  
    return numberArray;
}
